module.exports = __webpack_public_path__ + "static/media/AMS_Logo_Web.426d63a2.svg";